import { computed, reactive, ref } from 'vue';
import CommercialReportsAPI from 'dashboard/api/commercialReports';

export const useCommercialReports = () => {
  const report = ref(null);
  const isLoading = ref(false);
  const error = ref(null);
  const filters = reactive({
    dateFrom: '',
    dateTo: '',
    assignedUserId: '',
    companyId: '',
    stageId: '',
    status: '',
  });

  const apiFilters = computed(() =>
    Object.fromEntries(
      Object.entries(filters).map(([key, value]) => [
        key.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`),
        value,
      ])
    )
  );

  const fetchReport = async () => {
    isLoading.value = true;
    error.value = null;
    try {
      const { data } = await CommercialReportsAPI.show(apiFilters.value);
      report.value = data.payload;
    } catch (requestError) {
      error.value = requestError;
    } finally {
      isLoading.value = false;
    }
  };

  const clearFilters = () => {
    Object.keys(filters).forEach(key => {
      filters[key] = '';
    });
    return fetchReport();
  };

  return { report, filters, isLoading, error, fetchReport, clearFilters };
};
